var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.1 16.7",
    style: {
      enableBackground: "new 0 0 19.1 16.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,16.6h-9c-1,0-1.8-0.8-1.8-1.8v-13c0-1,0.8-1.8,1.8-1.8h9c1,0,1.8,0.8,1.8,1.8v2c0,0.4-0.4,0.8-0.8,0.8 s-0.8-0.4-0.8-0.8v-2c0-0.1-0.1-0.2-0.2-0.2h-9c-0.1,0-0.2,0.1-0.2,0.2v13c0,0.1,0.1,0.2,0.2,0.2h9c0.1,0,0.2-0.1,0.2-0.2v-2 c0-0.4,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8v2C12.7,15.8,11.9,16.6,10.9,16.6z M15.4,11.6c-0.2,0-0.4-0.1-0.6-0.2 c-0.3-0.3-0.3-0.8,0-1.1L16,9.1H6.9c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8H16l-1.1-1.1c-0.3-0.3-0.3-0.8,0-1.1 c0.3-0.3,0.8-0.3,1.1,0l2.4,2.4c0.4,0.4,0.4,1,0,1.4L16,11.4C15.8,11.5,15.6,11.6,15.4,11.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.59489857bcc5742106234550e94cd764.svg";
export { ForwardRef as ReactComponent };